<template>
  <app-card class="flex flex-col is-borderless">
    <div
      class="mb-12 relative"
      :class="{
        'bg-pattern bg-primary-500': !pending && member.primary,
        'bg-pattern-primary': !pending && !member.primary,
        'bg-pattern-grey': pending
      }"
    >
      <app-badge
        v-if="pending"
        icon="user-circle"
        class="mt-4 ml-4 absolute pin-t pin-l"
      >
        Pending
      </app-badge>
      <app-badge
        v-if="member.primary"
        icon="star"
        class="mt-4 ml-4 absolute pin-t pin-l"
      >
        Primary
      </app-badge>
      <card-actions
        v-if="!authUserIsMember && !member.primary && canModifyTeam"
        class="text-right -mb-12 mt-4 mr-4"
      >
        <ul class="list-reset text-sm text-center">
          <li
            v-if="authUser.primary && !pending"
            class="p-2"
          >
            <button
              class="block w-full py-1 hover:text-primary-800 text-black"
              type="button"
              @click="
                $emit('team:update', { action: 'primary', id: member.id })
              "
            >
              Make primary
            </button>
          </li>
          <li class="p-2">
            <button
              class="block w-full py-1 hover:text-primary-800 text-black"
              type="button"
              @click="$emit('team:update', { action: 'role', id: member.id })"
            >
              Make {{ roleLable }}
            </button>
          </li>
          <li class="p-2 border-t border-grey-200">
            <button
              class="block w-full py-1 text-negative-500 hover:text-negative-800 font-bold text-center disabled:"
              type="button"
              @click="$emit('team:delete', { id: member.id })"
            >
              Remove
            </button>
          </li>
        </ul>
      </card-actions>
      <div
        class="w-24 h-24 mx-auto text-white font-bold text-2xl mt-12 -mb-12 flex justify-center items-center border-4 border-white relative"
        :class="{
          'bg-primary-700': !pending,
          'bg-grey-700': pending
        }"
      >
        <template v-if="initials">
          {{ initials }}
          <div
            v-if="!member.primary"
            class="p-1 border-2 border-white bg-primary-200 text-primary-900 absolute pin-b pin-r z-10 -mb-1 flex items-center justify-center w-6 h-6 text-2xs leading-none font-bold"
            style="cursor:help;"
            :title="member.role | sentencecase"
          >
            {{ member.role.substring(0, 1).toUpperCase() }}
          </div>
        </template>
        <icon v-else icon="user" class="icons-grey w-10 h-10 block" />
      </div>
    </div>
    <div class="pt-3 pb-6 px-4 text-center leading-normal">
      <h2 class="text-base">
        {{ user.name }}
      </h2>
      <p v-if="pending" class="italic text-grey-600 text-xs">
        Invitation Pending
      </p>
      <p v-if="user.job_title" class="text-sm">
        {{ user.job_title }}
      </p>
      <p class="mt-3">
        <icon icon="at" class="w-4 h-4 icons-primary align-text-bottom mr-1" />
        <a :href="`mailto:${user.email}`">{{ user.email }}</a>
      </p>
      <p v-if="user.telephone">
        <icon
          icon="phone-outgoing-call"
          class="w-4 h-4 icons-primary align-text-bottom mr-1"
        />
        {{ user.telephone }}
      </p>
    </div>
  </app-card>
</template>

<script>
export default {
  name: "TeamCard",
  props: {
    member: {
      type: Object,
      required: true
    },
    partnerId: {
      type: Number,
      required: true
    },
    canModifyTeam: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    authUser() {
      return window._user || {};
    },
    authUserIsMember() {
      return this.authUser.id === this.user.id;
    },
    user() {
      return this.member.user;
    },
    initials() {
      if (!this.user.name) return false;
      const split = this.user.name.split(" ");
      let initial = split[0][0];
      return split[1] ? initial + split[1][0] : initial;
    },
    roleLable() {
      return this.member.role === "editor" ? "viewer" : "editor";
    },
    pending() {
      return !this.user.email_verified_at;
    }
  }
};
</script>
